// file-upload.service.js

import { IP_ADRESS } from './../../../deploy_conf.js'
import * as axios from 'axios'

const BASE_URL = IP_ADRESS

function upload (formData) {
  const url = `${BASE_URL}api/profile`
  return axios.post(url, formData)
  // get data
    .then(x => x.data)
  // add url field
    .then(x => Object.assign({},
      x, { url: `/api/images/${x.id}` }))
}

export { upload }



// WEBPACK FOOTER //
// ./src/components/FileUpload/file-upload.service_profile.js